import 'firebase/compat/firestore';
import { myFirebase } from '@/firebaseConfig/firebaseConfig';
import { useMemo, useState } from 'react';

import { setCache, getCache } from '@/utils/CacheController';
import { CACHE_KEYS } from '@/utils/cacheKeys';

import { useSensorsContext } from '@/contexts/SensorsContext';

import { FirebaseTimestamp, UserId, UserInfo } from '@/models';

import { Assignments, KinematicModelOptions } from '@/plugins/QSenseHubControl/types';

const db = myFirebase.firestore();
// const storage = myFirebase.storage();

type UseHardwareHook = {
  isLoading: boolean;
  isError: Error | undefined;
  errorMessage: string;
  clearError: () => void;
  getConfig: () => {
    KinematicModel: KinematicModelOptions;
    Whitelist: string[];
    Assignments: Assignments[];
    NetworkKey: number;
    DeviceState: string;
  };
};

export const useHardware = (): UseHardwareHook => {
  const [isError, setIsError] = useState<Error | undefined>();
  const { state } = useSensorsContext();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getConfig = () => {
    setIsLoading(true);
    const whitelist = state.sensorsInDatabase.map((sensor) => sensor.macAddress_LE ?? '');
    const assignments: Assignments[] = state.sensorsInDatabase.map((sensor) => {
      return { [sensor.macAddress_LE ?? '']: sensor.title };
    });

    const networkKey = state.networkKey;

    const deviceState = state.deviceState;

    const KinematicModel: KinematicModelOptions = 'ORYXGO';
    const config = {
      KinematicModel: KinematicModel,
      Whitelist: whitelist,
      Assignments: assignments,
      NetworkKey: networkKey,
      DeviceState: deviceState,
    };
    setIsLoading(false);
    return config;
  };

  // Called to close the error Toast
  const clearError = () => {
    setIsError(undefined);
  };

  const hook: UseHardwareHook = {
    isLoading: isLoading,
    isError: isError,
    errorMessage: errorMessage,
    clearError: clearError,
    getConfig: getConfig,
  };

  return useMemo(() => hook, [isLoading, isError, errorMessage, clearError]);
};
